

export default {
    
    approverName : state => (id) => {
        return state.approvers.find(a => a.approverId === id)
        // let approver = []
        // for(var e = 0; e < state.approvers.length; e++) {
        //     approver.push(state.approvers[e].approver)
        // }
        // return approvers.filter((a) => a.approver.userId === id)
    } ,

    employeeFiledLeave: state => (employeeFiledLeaveId) => {
        return state.employeeFiledLeaves.find(u => u.employeeFiledLeaveId === employeeFiledLeaveId)
    },
    

}